export default class Scrollino {
    constructor(asscroll = false) {
        // Init
        this.currentScrollTop = 0
        this.prevScrollTop = 0
        this.currentDir = false
        this.isHooked = true
        this.wasJustHooked = true
        this.hookTop = window.innerWidth < 1024 ? 76 : 60
        this.header = document.querySelector('.o-header')

        // Initial hooked class
        document.body.classList.add('-hooked')

        // Listen Scroll
        if(asscroll) {
            asscroll.on('scroll', scrollPos => this.listenScroll(scrollPos))
        } else {
            window.addEventListener('scroll', () => {
                this.listenScroll()
            }, false)
        }
    }

    listenScroll(scrollPos = false){
        if(scrollPos !== false) {
            this.currentScrollTop = Math.round(scrollPos)
        } else {
            this.currentScrollTop = Math.round(window.pageYOffset) || Math.round(document.documentElement.scrollTop)
        }
        // On down scroll
        if (!this.currentDir && this.currentScrollTop > this.prevScrollTop) {
           document.body.setAttribute('data-scroll', 'down')
           this.currentDir = true
            // Was just hooked ?
            if(window.innerWidth < 1024 && this.wasJustHooked) {
                document.body.classList.remove('-wasJustHooked')
                this.wasJustHooked = false
            }
        // On up scroll
        } else if (this.currentDir && this.currentScrollTop < this.prevScrollTop) {
           document.body.setAttribute('data-scroll', 'up')
           this.currentDir = false
            // Was just hooked ?
            if(window.innerWidth < 1024 && this.wasJustHooked) {
                document.body.classList.remove('-wasJustHooked')
                this.wasJustHooked = false
            }
        }
        // Is hooked ?
        if(this.isHooked && this.currentScrollTop > this.hookTop) {
            document.body.classList.remove('-hooked')
            this.isHooked = false
            // Was just hooked temporary class
            document.body.classList.add('-wasJustHooked')
            this.wasJustHooked = true
            setTimeout(() => {
                document.body.classList.remove('-wasJustHooked')
                this.wasJustHooked = false
            }, window.innerWidth < 1024 ? 750 : 1000)
        } else if(!this.isHooked && this.currentScrollTop <= 0) {
            document.body.classList.add('-hooked')
            this.isHooked = true
        }
        this.prevScrollTop = this.currentScrollTop
        // console.log(this.prevScrollTop)
    }
}